import { render, staticRenderFns } from "./NewsCategoryListcomponent.vue?vue&type=template&id=d65f8478"
import script from "./NewsCategoryListcomponent.vue?vue&type=script&lang=js"
export * from "./NewsCategoryListcomponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports